// extracted by mini-css-extract-plugin
export var attribution = "_b6-4";
export var authorName = "_b6-5";
export var quote = "_b6-3";
export var testimonial = "_b6-2";
export var trustedBy = "_b6-0";
export var trustedByLabel = "_b6-1";